const mySwiper = new Swiper('.Slider .swiper', {
  initialSlide: 1,
  slidesPerView: 1,
  spaceBetween: 16,
  loop: true,
  loopAdditionalSlides: 1,
  speed: 1500,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  preloadImages: false,
  lazy: {
    loadPrevNext: true,
  },
  grabCursor: true,
  watchSlidesProgress: true,
  breakpoints: {
    990: {
      slidesPerView: 2,
    }
  },
  pagination: {
    el: '.swiper-pagination',  // ページネーションの要素
    clickable: true,           // クリックでスライドを変更
  },
});

const mySwiper2 = new Swiper('.Slider2 .swiper', {
  initialSlide: 1,
  slidesPerView: 1,
  spaceBetween: 16,
  loop: true,
  loopAdditionalSlides: 1,
  speed: 1500,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  preloadImages: false,
  lazy: {
    loadPrevNext: true,
  },
  grabCursor: true,
  watchSlidesProgress: true,
  pagination: {
    el: '.swiper-pagination',  // ページネーションの要素
    clickable: true,           // クリックでスライドを変更
  },
});
